import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Request interceptor - attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - handle 401 auth errors + retry transient network failures
let isRedirecting = false;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const config = error.config || {};
    const isAuthEndpoint = config.url?.includes('/auth/');

    // Auto-retry transient network errors (no response, 502, 503, 504)
    const isTransient = !error.response || [502, 503, 504].includes(status);
    if (isTransient && config.method && config.method.toLowerCase() === 'get' && !config._retryCount) {
      config._retryCount = 1;
      await new Promise(r => setTimeout(r, 1500));
      try { return await api.request(config); } catch (e) { /* fall through */ }
    }

    // 401 = expired or invalid token. Clear session and redirect to login.
    // Skip for auth endpoints (login/register) to show their own error messages.
    if (status === 401 && !isAuthEndpoint && !isRedirecting) {
      isRedirecting = true;
      console.warn(`[API] 401 Unauthorized on ${config.url} — session expired, redirecting to login`);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;